import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import { PerfilUsuario } from '../../../../interfaces/perfil-usuario.interface'
import { getFechaCA } from '../../../../utils/stringDate'
import './styles/suscripcion.css'
import { formatearNum } from '../../../DetalleFactura/Components/VisualizacionFactura/TotalesDetalle'

const MiSuscripcion = () => {
  const profileData: PerfilUsuario = useSelector((state: State) => state.gestionUsuario.perfilUsuario)

  const width = () => {    
    if (!isNaN(profileData?.facturas_emitidas) && !isNaN(profileData?.facturas_maximas)) {
      return `${(profileData.facturas_emitidas * 100) / profileData.facturas_maximas}%`
    }
    return '0'
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        <form
          className='form-content'
          data-wf-page-id='64b58c72be2b65200b1e6fa6'
          data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
          
          style={{marginBottom: '5%'}}
        >
          <div>
            <h3 className='card-title l'>Mi Suscripción</h3>
          </div>
          <div className='form-separator'></div>
          <div>
            <p className='card-mi-suscripcion-subtitle'>Facturas emitidas</p>
            <div className='car-mi-suscripcion-progress-grey'>
              <div className='car-mi-suscripcion-progress-secondary' style={{width: `${width()}`}}></div>
            </div>
            <p className='card-mi-suscripcion-text'>
              <span style={{color: '#13AD90'}}>{profileData?.facturas_emitidas || '0'}</span> Facturas
              emitidas de {profileData?.facturas_maximas || '0'}
            </p>
          </div>
          <div>
            {
              profileData?.plan && profileData?.fecha_expiracion && 
              (
                <div className='suscripcion-plan-container'>
                  <div className='w-100 suscripcion-detail'>
                    {/* <div>
                      <p className='card-mi-suscripcion-subtitle'>Plan</p>
                      <p className='card-mi-suscripcion-text'>{profileData?.plan || ''}</p>
                    </div> */}
                    <div>
                      <p className='card-mi-suscripcion-subtitle'>Fecha máxima de pago</p>
                      <p className='card-mi-suscripcion-text'>{getFechaCA(profileData?.fecha_expiracion || '')}</p>
                    </div>
                  </div>
                  <div className='w-100 suscripcion-detail'>
                    <div className='select-plan-facturas-container'>
                      <div style={{overflowX: 'auto', width: '100%'}}>
                        <table className="table-plan-suscripcion" style={{margin: '0 auto'}}>
                          <thead>
                              <tr>
                                <td className='td-plan-body selected'>{profileData?.plan}</td>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                <td className='td-plan-body selected'>Cantidad máxima de documentos a emitir<br/> {profileData?.facturas_maximas.toLocaleString('es-SV', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                              </tr>
                              <tr>
                                <td className='td-plan-body selected'>Precio (USD - Dólar estadounidense)<br/> {formatearNum(parseInt(profileData?.precio))}</td>
                              </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  
                </div>
              )
            }
        </div>
        </form>
      </div>
    </div>
  )
}

export default MiSuscripcion
